import React, { useState, useEffect, Component } from 'react';
import { MdClose, MdInfoOutline } from 'react-icons/md';
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillFolder } from "react-icons/ai";
import Loader from "react-loader-spinner";
import { toastMessage } from '../utils/toast';
import * as formActions from '../../Redux/Actions/form';
import { Input } from '../Ui/Input';
import { Button } from '../Ui/Button';
import PreviewImgModal from '../DocumentVault/previewImg';
import DocumentDeleteModal from '../DocumentVault/deleteDocument';

const DisplayDocument = ({index, thumbnailUrl, contentType, documentId, fileName, handlePreviewDocument, setDeleteModal, setDeleteDocumentID, handleOk}) => {
    fileName = (fileName && fileName.length > 10) ? fileName.slice(0, 10) + '..' : fileName;
    let imgType = contentType.includes('image');
    return(
        <div key={index} className="document font-weight-bold my-4">
            {imgType && <div className="font-size-h1 position-absolute font-size-h1-xl right-0 p-2 d-flex" onClick={() => handlePreviewDocument(documentId)}><MdInfoOutline /></div>}
            <div style={{width: 'auto', height: '111px', margin: '0 auto'}} onClick={() => handleOk(documentId, fileName)}>
                {imgType ? <img src={thumbnailUrl} alt="Thumbnail" width="100%" height="100%" />
                : <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '150px', height: 'auto'}} />}
            </div>
            <div className="position-absolute bottom-0 bg-white d-flex col-12 align-items-center justify-content-lg-between p-3 m-0 w-100">
                <p className="m-0 p-0 col-10" onClick={() => handleOk(documentId, fileName)}>{fileName}</p>
                <AiOutlineDelete className="cursor-pointer col-2 p-0" style={{fontSize: '20px'}} onClick={() => {setDeleteModal(true); setDeleteDocumentID(documentId)}} />
            </div>
        </div>
    )
};

const DocumentVaultModal = ({ title, userID, data, loading, showModal, handleOk, handleCancel, isArabic, handleReloadDocumentVault }) => {

    const [tag, setTag] = useState([]);
    const [selectedTag, setSelectedTag] = useState('');
    const [imgSrcModal, setImgSrcModal] = useState(false);
    const [imgSrcModalLoading, setImgSrcModalLoading] = useState(false);
    const [imgSrc, setImgSrc] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteDocumentID, setDeleteDocumentID] = useState('');
    const [deleteDocumentLoading, setDeleteDocumentLoading] = useState(false);

    useEffect(() => {
        setTag(Object.keys(data));
    }, [data])

    const handlePreviewDocument = (documentID) => {
        setImgSrcModal(true);
        setImgSrcModalLoading(true);
        formActions.previewDocument(userID, documentID).then(res => {
            setImgSrc(res.data);
            setImgSrcModalLoading(false);
        }).catch(err => {
            console.log('Something Went Wrong', err);
        });
    };

    const handleRemoveDocument = (documentID) => {
        setDeleteDocumentLoading(true);
        formActions.removeDocument(userID, documentID).then(res => {
            handleReloadDocumentVault();
            setDeleteModal(false);
            setDeleteDocumentLoading(false);
            toastMessage('success', `Successfully deleted the document`);
        }).catch(err => {
            console.log('Something Went Wrong', err);
        });
    };

    return (
        <div>
            <div className="modal" style={{display: ((imgSrcModal || deleteModal) ? '' : showModal ? 'block': ''), overflow: 'scroll'}}>
                <div className="modal-dialog modal-dialog-centered" style={{minHeight: 'calc(100% - 0rem)'}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel}>
                                <MdClose style={{color: '#121180'}} className="fa-lg" />
                            </button>
                        </div>
                        <div className="modal-body" style={{padding: '0.7rem'}}>
                            {(selectedTag !== '') && <div className="mx-4 mt-4">
                                <span className="card-label font-weight-bolder cursor-pointer" onClick={() => setSelectedTag('')}>All</span>
                                <span className="card-label font-weight-bolder mr-2 ml-2">/</span>
                                <span className="card-label font-weight-bolder text-dark">{selectedTag}</span>
                            </div>}
                            <div className="d-flex flex-wrap justify-content-around align-items-center" style={{height: '300px', overflow: 'scroll'}}>
                                {loading ? <Loader type="ThreeDots" color="#121180" height={40} width={40} /> 
                                    : ((Object.keys(data).length === 0) || (tag.length === 0)) ? <h5 className="d-flex align-items-center m-0">{isArabic ? 'لاتوجد بيانات' : 'No data found'}</h5>
                                        : ((selectedTag === '') ? (tag.map(tag => ((tag !== 'undefined') && (tag !== '_')) ? <div key={tag} onClick={() => setSelectedTag(tag)} className="document d-flex align-items-center justify-content-center font-weight-bold my-4" style={{height: '50px', borderRadius: '3px'}}><AiFillFolder className="icon-xl mr-3" /> {tag}</div> 
                                            : <>{data.undefined && data.undefined.map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                                                <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleOk={handleOk} />)}
                                                {data._ && data._.map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                                                <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleOk={handleOk} />)}
                                            </>
                                        )) : data[selectedTag].map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                                            <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleOk={handleOk} />
                                        ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
            {imgSrcModal && <PreviewImgModal loading={imgSrcModalLoading} data={imgSrc} showModal={imgSrcModal} handleCancel={() => setImgSrcModal(false)} />}
            {deleteModal && <DocumentDeleteModal showModal={deleteModal} loading={deleteDocumentLoading} handleOk={() => handleRemoveDocument(deleteDocumentID)} handleModalClose={() => setDeleteModal(false)} />}
        </div>
    );
};

class DocumentUploadModal  extends Component {

    state = {
        name: ''
    };

    componentDidMount(){
        let {data} = this.props;
        for(let i=0; i <= data.files.length; i++) {
            let woExtensionName = data.files[i] && data.files[i].name.split('.');
            this.setState({
                ['name'+(i+1)]: woExtensionName && woExtensionName[0],
                ['extension'+(i+1)]: woExtensionName && woExtensionName[1]
            });
        }
    }

    render(){
        const { title, data, showModal, loading, handleOk, handleCancel } = this.props;
        let fileKeys = data.files && Object.keys(data.files);
        
        return(
            <div>
                <div className="modal" style={{display: (showModal ? 'block': ''), overflow: 'scroll'}}>
                    <div className="modal-dialog modal-dialog-centered" style={{minHeight: 'calc(100% - 0rem)'}}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{title}</h5>
                                <button type="button" className="close" aria-label="Close" onClick={handleCancel}>
                                    <MdClose style={{color: '#121180'}} className="fa-lg" />
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex flex-column justify-content-center" style={{minHeight: '350px', overflow: 'scroll'}}>
                                    <div>
                                        <div className="d-flex align-items-center justify-content-center" style={{overflow: 'scroll', margin: 0}}>
                                            {fileKeys && fileKeys.map(id => {
                                                let imgType = data.files && data.files[id] && data.files[id].type.includes('image');
                                                return (
                                                    imgType ? <img key={id} alt="Document Preview" src={URL.createObjectURL(data.files[id])} style={{ width: '50%', height: '50%' }} />
                                                        : <img key={id} src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '150px', height: 'auto'}} />
                                                )}
                                            )}
                                        </div>
                                    </div>
                                    {fileKeys && fileKeys.map(id => {
                                        id = parseInt(id)+1;
                                        return <Input key={id} onChange={e => this.setState({['name'+id]: e.target.value})} value={this.state['name'+id]} label={`File Name ${id}`} required={true} />
                                    })}
                                    <Button disabled={loading} type="button" className="mt-8" onClick={() => handleOk(this.state)}>
                                        Upload {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </div>
        );
    };
};

export { DocumentVaultModal, DocumentUploadModal };